import { getPlatformServices } from '../../platform'
import ApiServiceClass from '../services/api-service'

let ApiService: ApiServiceClass | null = null

const apiServiceInitiator = (): ApiServiceClass => {
  if (!ApiService) {
    ApiService = new ApiServiceClass(getPlatformServices().getApiServerUrl())
  }

  return ApiService
}

export default apiServiceInitiator
